import React, { useCallback, useEffect } from 'react';
import Box from 'fe-design-base/atoms/Box';
import Text from 'fe-design-base/atoms/Text/Text';
import Alert from 'fe-design-base/molecules/Alert';
import PropTypes from 'prop-types';

import { cxHelpers } from 'util/className';
import { toI18n } from 'util/i18n';

const { cx } = cxHelpers('TaxForm');

import { I18N_TAX_FORMS_PATH } from 'features/team/components/TaxEntryForm/constants';
import {
  ADD_TEAM_PAYROLL_FLOW_STEP,
  EVENT_ACTIONS,
} from 'features/teamView/tracking';

import { TRACK_ACTION_TYPES } from 'util/tracking_constants';
import { useTrackUx } from 'util/uxEvents';

import TaxFormField from './TaxFormField';

const TaxForm = ({
  description,
  parameters,
  isFederal,
  isBlocking,
  isTeamDrawer = true,
}) => {
  const trackUx = useTrackUx();
  useEffect(() => {
    if (isTeamDrawer) {
      trackUx(EVENT_ACTIONS.PAGE_VIEWED, TRACK_ACTION_TYPES.VIEW, {
        add_team_payroll_flow_step: isFederal
          ? ADD_TEAM_PAYROLL_FLOW_STEP.FEDERAL
          : ADD_TEAM_PAYROLL_FLOW_STEP.STATE,
      });
    }
  }, [isFederal, trackUx, isTeamDrawer]);

  const renderField = useCallback(
    ({ depends_on, ...params }) => (
      <TaxFormField key={params.name} dependsOn={depends_on} {...params} />
    ),
    []
  );

  return (
    <Box className={cx({ isFederal, isBlocking })}>
      {isTeamDrawer && (
        <>
          <Box>
            <Text color="mono900" variant="heading3">
              {description}
            </Text>
          </Box>
          <Box mb={24}>
            <Text color="mono700" variant="body">
              {toI18n(`${I18N_TAX_FORMS_PATH}.title_desc`)}
            </Text>
          </Box>

          {!isBlocking && (
            <Box mb={24}>
              <Alert variant="info">
                {toI18n(
                  `${I18N_TAX_FORMS_PATH}.${
                    isFederal ? 'optional_federal_form' : 'optional_state_form'
                  }`
                )}
              </Alert>
            </Box>
          )}
        </>
      )}

      {parameters.map(renderField)}
    </Box>
  );
};

TaxForm.propTypes = {
  description: PropTypes.string,
  parameters: PropTypes.array,
  isFederal: PropTypes.bool,
  isBlocking: PropTypes.bool,
};

export default TaxForm;
